module.exports = __webpack_public_path__ + "static/media/veneto-village-28.1523d476.jpg";